import { jsxs, jsx } from "react/jsx-runtime";
import { get, ModalOverlay, Flex, Box, Text, Typist, ModalContent } from "@betterment/style-closet-react";
import styled from "@emotion/styled";
import VisuallyHidden from "@reach/visually-hidden";
import { keyframes } from "@emotion/core";
const curve = "cubic-bezier(0.65, 0, 0.45, 1)";
const stroke = keyframes`
 100% {
  stroke-dashoffset: 0;
 }
`;
const StyledSvg = styled.svg`
  stroke-width: 3;
  width: 10rem;
  margin: 0 auto 2rem;
  fill: none;
  stroke: ${get("colors.bmtWhite")};
`;
const StyledCircle = styled.circle`
  stroke-dasharray: 218;
  stroke-dashoffset: 218;
  animation: ${stroke} 0.6s ${curve} forwards;
  fill: none;
  stroke: ${get("colors.bmtWhite")};
`;
const StyledPolyline = styled.polyline`
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: ${stroke} 0.3s ${curve} 0.8s forwards;
  fill: none;
  stroke: ${get("colors.bmtWhite")};
`;
function AnimatedCheckmark() {
  return /* @__PURE__ */ jsxs(StyledSvg, { preserveAspectRatio: "xMidYMid meet", viewBox: "0 0 72 72", children: [
    /* @__PURE__ */ jsx(StyledPolyline, { points: "23.3 37.5 31.8 45.9 49.5 28.1 " }),
    /* @__PURE__ */ jsx(StyledCircle, { cx: "36", cy: "36", r: "34.5" })
  ] });
}
const Content = styled(ModalContent)`
  &&& {
    max-width: none;
    width: 100%;
  }
`;
const SuccessOverlay = ({ message, onCompletion }) => {
  return /* @__PURE__ */ jsx(ModalOverlay, { children: /* @__PURE__ */ jsx(Content, { my: "0", mx: "0", "aria-label": message, children: /* @__PURE__ */ jsxs(Flex, { p: "4", height: "100vh", alignItems: "center", justifyContent: "center", flexDirection: "column", bg: "bmtNavy", children: [
    /* @__PURE__ */ jsx(Box, { mb: "8", children: /* @__PURE__ */ jsx(AnimatedCheckmark, {}) }),
    /* @__PURE__ */ jsx(VisuallyHidden, { children: /* @__PURE__ */ jsx(Text, { children: message }) }),
    /* @__PURE__ */ jsxs(Typist, { onTypingDone: onCompletion, startDelay: 500, children: [
      /* @__PURE__ */ jsx(Text, { color: "bmtWhite", fontWeight: "bold", lineHeight: "2", fontSize: "4", children: message }),
      /* @__PURE__ */ jsx(Typist.Delay, { ms: 800 })
    ] })
  ] }) }) });
};
export {
  SuccessOverlay as S
};
//# sourceMappingURL=SuccessOverlay-DjKS2rlN.js.map
